// --- Our Modules --------------------------------------------------------------------------------
import useTranslation from "@/hooks/useTranslation";
import type { TySubscriptionStatus } from "@/types";
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    /** `null` renders the "no subscription" pill rather than nothing, so a store never reads as blank. */
    status: TySubscriptionStatus | null;
};

// --- Logic --------------------------------------------------------------------------------------

/** Groups the seven statuses into the four tones the UI actually distinguishes. */
const TONES: Record<TySubscriptionStatus, string> = {
    active: "good",
    coming: "good",
    pending: "warn",
    grace: "warn",
    paused: "bad",
    canceled: "mute",
    ended: "mute",
};

export default function StatusBadge({ status }: Props) {
    const t = useTranslation();

    if (!status)
        return (
            <span className="status-badge" data-tone="mute">
                {t.stores.noSubscription}
            </span>
        );

    return (
        <span className="status-badge" data-tone={TONES[status]}>
            {t.enums.subscriptionStatus[status]}
        </span>
    );
}
